import React, {Component} from 'react';
import {Router, Route} from 'react-router';
import SignIn from '../containers/Layouts/Default/Signin';
import AuthWrapper from '../containers/AuthWrapper';
import {Switch} from 'react-router-dom';
// User Components
import UserLayout from '../containers/Layouts/User';
import Home from './../containers/Layouts/User/Home';
import UserPage from './../containers/Layouts/User/UserPage';
import Cases from './../containers/Layouts/User/Cases';
import Profile from './../containers/Layouts/User/Profile';
import CaseDetails from './../containers/Layouts/User/CaseDetails';

// Admin Components
import AdminLayout from '../containers/Layouts/Admin';
import Dentists from './../containers/Layouts/Admin/Dentists';
import AllCases from './../containers/Layouts/Admin/AllCases';
import Dashboard from '../containers/Layouts/Admin/dashboard';
import AdminPatients from './../containers/Layouts/Admin/Patients';
import AvailableUnits from './../containers/Layouts/Admin/AvailableUnits';
import AdminCaseDetails from './../containers/Layouts/Admin/AdminCaseDetails';
import DailyReport from './../containers/Layouts/Admin/DailyReport';
import PatientDetails from './../containers/Layouts/Admin/PatientDetails';
import DentistDetails from './../containers/Layouts/Admin/DentistDetails';
import Chat from '../containers/Chat';

// Default Components
import DefaultLayout from '../containers/Layouts/Default';
import Welcome from '../containers/Layouts/Default/Welcome';
import Registration from '../containers/Layouts/Default/Register';
import VerifyUser from '../containers/Layouts/Default/VerifyUser';
import ResetPassword from './../containers/Layouts/Default/ResetPassword';
import ForgetPassword from './../containers/Layouts/Default/ForgetPassword';
import Notfound from './../containers/Layouts/Default/Notfound';

class Routes extends Component {
    wrap(Component, props, auth) {
        let Layout;
        switch (auth) {
            case 'admin': {
                Layout = <AdminLayout><Component {...props} /> </AdminLayout>;
                break;
            }
            case 'user': {
                Layout = <UserLayout><Component {...props} /></UserLayout>;
                break;
            }
            default: {
                Layout = <DefaultLayout><Component {...props} /></DefaultLayout>;
            }
        }
        return (
            <AuthWrapper {...props} layout={auth}>
                {Layout}
            </AuthWrapper>
        );
    }

    render() {
        return (
            <Router history={this.props.history}>
                <Switch>
                    {/*Dentist Pages Routes*/}
                    <Route exact path='/' render={props => this.wrap(Welcome, this.props, null)}/>
                    <Route exact path='/account' render={props => this.wrap(UserPage, this.props, 'user')}/>
                    <Route exact path='/account/profile' render={props => this.wrap(Profile, this.props, 'user')}/>
                    <Route exact path='/case-summary/:patientId?' render={props => this.wrap(Cases, props, 'user')}/>
                    <Route exact path='/case-details/:caseId' render={props => this.wrap(CaseDetails, props, 'user')}/>

                    {/*Admin Pages Routes*/}
                    <Route exact path='/sm-admin' render={props => this.wrap(Dashboard, this.props, 'admin')}/>
                    <Route exact path='/sm-admin/cases' render={props => this.wrap(AllCases, this.props, 'admin')}/>
                    <Route exact path='/sm-admin/dentists' render={props => this.wrap(Dentists, this.props, 'admin')}/>
                    <Route exact path='/sm-admin/patients' render={props => this.wrap(AdminPatients, this.props, 'admin')}/>
                    <Route exact path='/sm-admin/available-units' render={props => this.wrap(AvailableUnits, this.props, 'admin')}/>
                    <Route exact path='/sm-admin/case-details/:caseId' render={props => this.wrap(AdminCaseDetails, props, 'admin')}/>
                    <Route exact path='/sm-admin/daily-report' render={props => this.wrap(DailyReport, props, 'admin')}/>
                    <Route exact path='/sm-admin/patients/:patientId' render={props => this.wrap(PatientDetails, props, 'admin')}/>
                    <Route exact path='/sm-admin/dentists/:dentistId' render={props => this.wrap(DentistDetails, props, 'admin')}/>
                    <Route exact path='/sm-admin/messages' render={props => this.wrap(Chat, this.props, 'admin')}/>

                    {/*Default Pages Routes*/}
                    <Route exact path='/sign-in' render={props => this.wrap(SignIn, this.props, null)}/>
                    <Route path='/verify/:token/:userId' render={props => <VerifyUser params={props}/>}/>
                    <Route exact path='/registration' render={props => this.wrap(Registration, this.props, null)}/>
                    <Route path='/reset-password/:token/:userId' render={props => <ResetPassword params={props}/>}/>
                    <Route exact path='/forget-password' render={props => this.wrap(ForgetPassword, this.props, null)}/>

                    <Route render={Notfound}/>
                </Switch>
            </Router>
        );
    }
}

export default Routes;

// '/me' req.me 401



// WEBPACK FOOTER //
// ./src/Router/Router.js